// Centralized social handles for all three SMG brands.
// Drop real URLs into each `url` field as you claim handles — any entry
// with a `null` url renders as a disabled/placeholder tile in the UI.
//
// The Footer picks the right block based on the current route:
//   /sports-management  → SMG Sports Management
//   /ralli              → Ralli
//   everything else     → SMG Media Group

export const SOCIAL_PROFILES = {
  smg: {
    label: 'SMG MEDIA',
    heading: 'Follow SMG Media Group',
    channels: [
      { name: 'instagram', handle: '@smgmediagroup',  url: null },
      { name: 'facebook',  handle: 'SMG Media Group', url: null },
      { name: 'linkedin',  handle: 'smg-media-group', url: null },
      { name: 'youtube',   handle: '@smgmediagroup',  url: null },
    ],
  },
  sports: {
    label: 'SMG SPORTS MANAGEMENT',
    heading: 'Follow SMG Sports Management',
    channels: [
      { name: 'instagram', handle: '@smgsportsmgt',  url: null },
      { name: 'facebook',  handle: 'SMG Sports Management', url: null },
      { name: 'linkedin',  handle: 'smg-sports-management', url: null },
      { name: 'youtube',   handle: '@smgsportsmgt',  url: null },
    ],
  },
  ralli: {
    label: 'RALLI',
    heading: 'Follow Ralli',
    channels: [
      { name: 'instagram', handle: '@playralli',  url: null },
      { name: 'facebook',  handle: 'Play Ralli',  url: null },
      { name: 'linkedin',  handle: 'play-ralli',  url: null },
      { name: 'youtube',   handle: '@playralli',  url: null },
    ],
  },
};

/** Route-aware helper used by the Footer. */
export function socialBrandForPath(pathname = '') {
  if (pathname.startsWith('/sports-management')) return 'sports';
  if (pathname.startsWith('/ralli')) return 'ralli';
  return 'smg';
}
